import _ from "lodash";
import { NUM_VALUE_TO_VOICE_SPEED,VOICE_SPEEDS, VOICE_SPEED_NORMAL } from "../constants/Constants";
import getClosest from "get-closest";
export class SyntheticVoiceProvider {
	eventListeners = {};
	start(data, config) {
		return Promise.reject(new Error(`Abstract function, must be implemented, unable to start voice provider data=${JSON.stringify(data)}; config=${JSON.stringify(config)}`));
	}
	stop() { }
	pause() { }
	resume() { }

	static getSpeedConstantFromValue(speed) {
		let result = VOICE_SPEED_NORMAL;
		if (_.isNumber(speed)) {
			const valueArray = _.keys(NUM_VALUE_TO_VOICE_SPEED);
			const closestIdx = getClosest.number(speed, valueArray);

			if (closestIdx !== -1) {
				const closestValue = valueArray[closestIdx];
				result = NUM_VALUE_TO_VOICE_SPEED[closestValue];
			}

		} else if (_.isString(speed)) {
			// See if it is in the array
			VOICE_SPEEDS.forEach(voiceSpeed => {
				if (voiceSpeed === speed) {
					result = voiceSpeed;
				}
			})
		}
		return result;
	}

	fireEvent(eventType, err) {
		if (this.eventListeners[eventType] && _.isArray(this.eventListeners[eventType])) {
			this.eventListeners[eventType].forEach(callback => {
				if (_.isFunction(callback)) {
					callback(err);
				}
			});
		}
	}

	addEventListener(type, callback) {
		if (!this.eventListeners[type]) {
			this.eventListeners[type] = [];
		}
		this.eventListeners[type].push(callback);
	}

	removeEventListener(type, callback) {
		if (this.eventListeners[type] && _.isArray(this.eventListeners[type])) {
			let _idx = -1;
			this.eventListeners[type].forEach((cb, idx) => {
				if (cb === callback) {
					_idx = idx;
				}
			});
			if (_idx > -1) {
				this.eventListeners[type].splice(_idx, 1);
			}
		}
		this.eventListeners[type].push(callback);
	}

	removeAllEventListeners(type) {
		this.eventListeners[type] = [];
	}
}

export class SyntheticVoiceTextToSpeechProvider extends SyntheticVoiceProvider {
	start(speechRequest, config) {
		this.speechRequest = speechRequest;
		const { text } = speechRequest;
		this.config = config;
		return this.speak(text, config);
	}
	speak(text) {
		return Promise.reject(new Error(`Abstract function, must be implemented, unable to speak text '${text}'`));
	}

	setDefaultLanguage(lang) {
		return Promise.reject(new Error(`Abstract function, must be implemented, unable to set default language ${lang}`));
	}
	setDefaultVoice(id) {
		return Promise.reject(new Error(`Abstract function, must be implemented, unable to set default voice ${id}`));
	}
	getVoices() { }
}

export class SyntheticVoiceAudioProvider extends SyntheticVoiceProvider {
	start(speechRequest, config) {
		this.speechRequest = speechRequest;
		const { uri } = speechRequest;
		this.config = config;
		return this.play(uri);
	}
	play(uri) {
		return Promise.reject(new Error(`Abstract function, must be implemented, unable to play ${uri}`));
	}
}